import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import $ from 'jquery'
import './Header.scss';
import logoImage from '../imgs/Element_28@4x.png'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import { DropdownButton, Dropdown, NavDropdown } from 'react-bootstrap';
import 'reactjs-popup/dist/index.css';


const links = [
    { to: '/transporter-training/', title: 'Transporter' },
    { to: '/bus-training/', title: 'Bus' },
    { to: '/lkw-training/', title: 'LKW' },
    { to: '/pkw-training/', title: 'PKW' },
    { to: '/motorad-training/', title: 'Motorrad' },
    { to: '/zuschuesse/', title: 'Zuschüsse' },
    { to: '/shop/', title: 'Shop' },
    { to: '/aktuelles/', title: 'Aktuelles' },
    { to: '/ueber-uns/', title: 'Über uns' },
    { to: '/kontakt/', title: 'Kontakt' },
]

const MenuItems = [
    {
        title: 'Marketing',
        path: '/marketing/',
        cName: 'dropdown-link'
    },
    {
        title: 'Design',
        path: '/design/',

        cName: 'dropdown-link'
    },
    {
        title: 'Fahrer',
        path: '/fahrer/',
        cName: 'dropdown-link'
    },
]

const dropdown = ["Fahrer", "Design", "Common"]


const Header = ({ children, gotoHome }) => (
    <div className='header-box'>
        <header className="header site-header">
            <h1 className="site-title" onClick={() => gotoHome()}>
                <img src={logoImage} className="header-logo"/>
            </h1>
            
            
        </header>
    </div>
)



export default connect(
    (state) => { return {} },
    (dispatch) => {
        return {
            gotoHome: () => window.location.href = "https://fsc-shop.vir-group.de/"
        }
    },
)(Header)


// WEBPACK FOOTER //
// ./src/components/Header.js